import Vue from "vue";
import Vuex from "vuex";
import user from "./module/user";
import app from "./module/app";
import spmanage from "./module/spmanage";
import getters from "./getters";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    spmanage
  },
  getters,
  plugins: [
    createPersistedState({
      paths: ["spmanage"]
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js